module.exports = __webpack_public_path__ + "img/settings.37d73ddd.svg";